import React from 'react';
import styled from 'styled-components';
import { spaceMixin, Alert } from '@zillow/constellation';

interface StyledErrorBoxProps {
    hideTopMargin?: boolean;
}

const StyledErrorBox = styled.div<StyledErrorBoxProps>`
    margin: ${({ hideTopMargin }) => (hideTopMargin ? 0 : spaceMixin('sm'))} auto;
`;

interface ErrorBoxProps {
    errorMessage: string;
    hideTopMargin?: boolean;
}

const ErrorBox = ({ errorMessage, hideTopMargin = false }: ErrorBoxProps) => (
    <StyledErrorBox data-testid="error-message" hideTopMargin={hideTopMargin}>
        <Alert appearance="error" body={errorMessage} />
    </StyledErrorBox>
);

export default ErrorBox;
